import axios from 'axios';

import { REACT_APP_API_URL } from 'src/constants/dotenv';

const client = axios.create({
  baseURL: REACT_APP_API_URL
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const isForm = typeof FormData !== 'undefined' && config.data instanceof FormData;

  if (isForm) {
    if (config.headers && 'Content-Type' in config.headers) {
      delete config.headers['Content-Type'];
    }
  } else {
    config.headers['Content-Type'] = 'application/json';
  }

  return config;
});

const appendToFormData = (formData, data, parentKey) => {
  if (data === undefined || data === null) {
    return;
  }

  if (
    data &&
    typeof data === 'object' &&
    'originFileObj' in data &&
    data.originFileObj instanceof File
  ) {
    if (!parentKey) {
      throw new Error('parentKey required for file field');
    }

    return formData.append(parentKey, data.originFileObj);
  }

  if (typeof File !== 'undefined' && data instanceof File) {
    if (!parentKey) {
      throw new Error('parentKey required for file field');
    }

    return formData.append(parentKey, data);
  }

  if (Array.isArray(data)) {
    if (!parentKey) {
      throw new Error('parentKey required for array field');
    }

    return data.forEach((value) => {
      appendToFormData(formData, value, parentKey); // same key, no [i]
    });
  }

  if (typeof data === 'object') {
    return Object.entries(data).forEach(([key, value]) => {
      const newKey = parentKey ? `${parentKey}[${key}]` : key;
      appendToFormData(formData, value, newKey);
    });
  }

  if (!parentKey) {
    throw new Error('parentKey required for primitive field');
  }

  formData.append(parentKey, String(data));
};

const get = async (URL, params) => {
  return await client.get(`${URL}`, { params }).then((response) => response);
};

const post = async (URL, payload) => {
  return await client.post(`${URL}`, payload).then((response) => response);
};

const post_form = async (URL, payload) => {
  const formData = new FormData();

  appendToFormData(formData, payload);

  return await client.post(URL, formData).then((response) => response);
};

const patch = async (URL, payload) => {
  return await client.patch(`${URL}`, payload).then((response) => response);
};

const patch_form = async (URL, payload) => {
  const formData = new FormData();

  appendToFormData(formData, payload);

  return await client.patch(`${URL}`, formData).then((response) => response);
};

const delete_req = async (URL) => {
  return await client.delete(`${URL}`).then((response) => response);
};

const apiClient = {
  post,
  post_form,
  get,
  patch,
  patch_form,
  delete_req
};

export { apiClient };
